import React from 'react';

const Card = ({ title, values, isPopup, items }) => {
	const renderValues = () => {
		if (Array.isArray(values)) {
			return (
				<ul className="common-list-component mt-1">
					{values.map((value, index) => (
						<li className="weight-700 gray_dark_01" key={index}>
							{value}
						</li>
					))}
				</ul>
			);
		}
		return <span className="regular-16 weight-700 gray_dark_01">{values}</span>;
	};

	return (
		<div
			className={`single-item d-flex flex-column aligin-items-center align-self-center ${
				isPopup ? 'cursor-pointer' : ''
			} p-3 mr-12`}
		>
			<div className="title gray_dark_01 regular-12">{title} </div>
			<p className="regular-14 gray_dark_01 weight-700 d-flex align-items-center">
				{renderValues()}{' '}
				{isPopup && (
					<img
						className="info-icon ml-1"
						src={`${process.env.PUBLIC_URL}/icons/info.svg`}
						width={18}
						height={18}
					/>
				)}
			</p>
			{isPopup && (
				<div className="all-brand-content shadow-8dp">
					<div className="d-flex flex-wrap all-brands scroll-y-label gap-2">
						{items?.map((name) => (
							<span key={name} className="regular-12 status radius gray_dark_01">
								{name}
							</span>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

const CardGrid = ({ cards }) => {
	return (
		<div className="scrollbar-on-hover">
			<div className="brand-market-and-category d-flex  scroll-x-label">
				{cards.map((card, index) => (
					<Card
						key={index}
						title={card?.title}
						values={card?.values}
						isPopup={card?.isPopup}
						items={card?.items}
					/>
				))}
			</div>
		</div>
	);
};

export default CardGrid;
